import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import Login from './pages/home/Login';
import Home from './pages/home/home';
import JDCallback from './pages/home/JDCallback';
import HomePageAfterJDConnection from './pages/home/homePageAfterJDConnection';
import ChooseData from './pages/home/chooseData';
import MasterConfiguration from './pages/master-configuration';
import Admin from './pages/admin';
import UserConfiguration from './pages/user-configuration';
import EditUserConfig from './pages/user-configuration/components/EditUserConfig';
import { Toaster } from 'react-hot-toast';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  // debugger
  const token = localStorage.getItem('origo_access_token') || localStorage.getItem('origo_auth_url');
  
  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className='bg-[#F3F3F9] dark:bg-gray-900 text-black dark:text-white font-poppins'>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/jd-callback" element={
            <ProtectedRoute>
              <JDCallback />
            </ProtectedRoute>
          } />
          <Route path="/choose-data" element={
            <ProtectedRoute>
              <ChooseData />
            </ProtectedRoute>
          } />
          <Route path="/homePage" element={
            <ProtectedRoute>
              <HomePageAfterJDConnection />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          } />
          <Route path="/admin/master-configuration" element={
            <ProtectedRoute>
              <MasterConfiguration />
            </ProtectedRoute>
          } />
          <Route path="/admin/user-configuration" element={
            <ProtectedRoute>
              <UserConfiguration />
            </ProtectedRoute>
          } />
          <Route path="/admin/edit-user-configuration/:organizationId" element={
            <ProtectedRoute>
              <EditUserConfig />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
      <div><Toaster position="top-right" /></div>
    </div>
  );
}

export default App;